import Text from 'components/_UI/Text';
import Navbar from 'components/commons/Navbar';
import { useCollapse } from 'context/general/Collapse';
import { useOnSelectMenu } from 'context/general/OnSelectMenu';
import EstablishmentsV2 from 'modules/establishment/EstablishmentsV2';
import Map from 'modules/events/map/Map';
import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import paths from 'routes/paths';
import styled, { css } from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import tabs from 'theme/tabs';
import indexPriority from 'theme/z-index';
import { Routes, Route, Outlet } from 'react-router-dom';
import TopActions from './TopActions';
import Icon from 'components/_UI/Icon';
import SelectLocation from 'components/_UI/SelectLocation';
import locationApi from 'api/requests/location';
import { useCurrentLocation } from 'context/user/CurrentLocation';
import ModalLocation from './ModalLocation';
import { useShowLocationModal } from 'context/general/ShowLocationModal';
import { useShowSearchOverlay } from 'context/general/ShowSearchOverlay';
import { useUserLocation } from 'context/user/UserLocation';
import { useUserLocale } from 'context/user/UserLocale';
import routeParams from 'theme/routeParams';
import InvitePermissionAlert from './InvitePermissionAlert';
import TeamInviteAlert from 'modules/dashboard/producer-access/TeamInviteAlert';
import { useBackButtonCollapse } from 'context/general/BackButtonCollapse';
import EventsV2 from 'modules/events/EventsV2';
import Footer from 'components/commons/Footer';
import ModalV2 from 'components/_UI/ModalV2';
import { useEventDetailModal } from 'context/events/EventDetailModal';
import { Row } from 'styled/alignment/Row';
import { ChevronDown, Home, MapPin, Star, Sunset, Search, X, Map as MapIcon, EyeOff, ArrowLeft } from 'lucide-react';
import HommeCollapse from 'modules/_common/HomeCollapse';
import MultipleEventsListV2 from 'modules/events/map/MultipleEventsListV2';
import { useMainCollapse } from 'context/main/MainCollapse';
import { useEventFilter } from 'context/events/EventFilter';
import { useEstablishmentFilter } from 'context/establishments/EstablishmentFilter';
import FiltersModal from 'modules/events/filters/FiltersModal';
import EstablishmentFiltersModal from 'modules/establishment/filters/EstablishmentFiltersModal';
import { useShowLoginModal } from 'context/general/ShowLoginModal';
import LoginModal from 'modules/onboarding/sign-in/LoginModal';
import EventDetailV2 from 'modules/events/detail/EventDetailV2';

export default function MainV2({ mobileView, setMobileView }) {
    const [latitude, setLatitude] = useState(false)
    const [longitude, setLongitude] = useState(false);
    const [renderMap, setRenderMap] = useState(false);
    const [selectedTab, setSelectedTab] = useState(
        window.location.pathname.includes(paths.establishments.home)
            ? tabs.establishment.slug
            : tabs.events.slug
    );
    const [dynamicData, setDynamicData] = useState(false);
    const { collapse, setCollapse } = useCollapse()
    const [renderTabCount, setRenderTabCount] = useState(0);
    const [filterClick, setFilterClick] = useState(false);
    const [eventClick, setEventClick] = useState(false);
    // const [touristicPlaceClick, setTouristicPlaceClick] = useState(false);
    const [locationLoading, setLocationLoading] = useState(true);

    const { onSelectMenu, setOnSelectMenu } = useOnSelectMenu();

    const [invitePermissionModal, setInvitePermissionModal] = useState(false);
    const [teamInviteModal, setTeamInviteModal] = useState(false);

    const { showLocationModal, setShowLocationModal } = useShowLocationModal();
    const { currentLocation, setCurrentLocation } = useCurrentLocation();
    const { userLocation, setUserLocation } = useUserLocation();
    const { userLocale, setUserLocale } = useUserLocale();
    const [searchParams, setSearchParams] = useSearchParams();
    const { backButtonCollapse, setBackButtonCollapse } = useBackButtonCollapse();
    const { eventDetailModal, setEventDetailModal } = useEventDetailModal();
    const { mainCollapse, setMainCollapse } = useMainCollapse();
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);
    const { showLoginModal, setShowLoginModal } = useShowLoginModal();
    const { eventFilter, setEventFilter } = useEventFilter();
    const { establishmentFilter, setEstablishmentFilter } = useEstablishmentFilter();
    const [mapVisible, setMapVisible] = useState(true);
    const { setShowSearchOverlay } = useShowSearchOverlay();

    const location = useLocation();
    const navigate = useNavigate();
    let cityAthorized = import.meta.env.VITE_PRODUCER_AUTHORIZED_CITIES.split(',');

    const isEventTab = location.pathname.includes(paths.events.home);
    const isEstablishment = location.pathname.includes(paths.establishments.home);

    useEffect(() => {
        let permissionObservable;

        navigator.permissions.query({ name: "geolocation" })
            .then((result) => {
                permissionObservable = result
                onPermissionChange(result)

                result.addEventListener('change', () => onPermissionChange(result));
            })
            .catch((err) => console.error('Permission query failed:', err));

        return () => {
            if (permissionObservable) {
                permissionObservable.removeEventListener('change', onPermissionChange)
            }
        }
    }, [])

    useEffect(() => {
        const permissionInvite = searchParams.get(routeParams.permissions.invitePermission);
        const permissionInviteEvent = searchParams.get(routeParams.permissions.invitePermissionEvent);

        if (permissionInvite) {
            setInvitePermissionModal({ type: permissionInvite, event: permissionInviteEvent });
        }

        const teamInvite = searchParams.get(routeParams.teams.invite);

        if (teamInvite) {
            setTeamInviteModal({
                type: teamInvite,
                teamName: searchParams.get(routeParams.teams.inviteTeamName),
                producerId: searchParams.get(routeParams.teams.inviteProducer),
            });
        }

    }, [onSelectMenu, selectedTab, showLocationModal]);

    useEffect(() => {
        if (location.pathname.includes(paths.events.home)) setSelectedTab(tabs.events.slug);
        if (location.pathname.includes(paths.establishments.home)) setSelectedTab(tabs.establishment.slug);
    }, [location.pathname]);

    function onCloseTeamInviteModal() {
        setTeamInviteModal(false);

        setSearchParams((prevSearchParams) => {
            const newSearchParams = new URLSearchParams(prevSearchParams);

            newSearchParams.delete(routeParams.teams.invite);
            newSearchParams.delete(routeParams.teams.inviteTeamName);
            newSearchParams.delete(routeParams.teams.inviteProducer);

            return newSearchParams;
        });
    }

    function onClosePermissionModal() {
        setInvitePermissionModal(false);

        setSearchParams((prevSearchParams) => {
            const newSearchParams = new URLSearchParams(prevSearchParams);

            newSearchParams.delete(routeParams?.permissions?.invitePermission);
            newSearchParams.delete(routeParams?.permissions?.invitePermissionEvent);

            return newSearchParams;
        });
    }

    async function getLocationModal(location) {
        if (currentLocation?.city) {
            return
        }
        try {
            const { data } = await locationApi.getLocation(location.lat, location.long)
            setCurrentLocation(data)
        } catch (error) {
            console.log('error')
        }
    }

    function upCollapse() {
        setCollapse({
            ...collapse,
            height: 'max',
            arrowPosition: 'both',
        })
    }

    function getGeolocationFromUser() {
        setLocationLoading(true);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error)
        }
    };

    function showLocation() {
        setShowLocationModal(true)
    }

    function success({ coords }) {
        if (coords) {
            const { latitude, longitude } = coords;

            setLatitude(latitude);
            setLongitude(longitude);
            setRenderMap(true);

            const data = { lat: latitude, long: longitude }
            setUserLocation(data);
            getLocationModal(data);
            setLocationLoading(false);

            if (!userLocale) {
                setUserLocale(data);
            }
        }

    };

    function error(error) {
        if (error) {
            setLatitude(false);
            setLongitude(false);
            setRenderMap(false);
            localStorage.removeItem('userLocation')
            const formatedObject = {
                lat: import.meta.env.VITE_BASE_LAT,
                long: import.meta.env.VITE_BASE_LONG
            }
            setUserLocation(formatedObject);
            getLocationModal(formatedObject);
            setLocationLoading(false);

            if (!userLocale) {
                setUserLocale(formatedObject);
            }
        }
    };

    function createDynamicData(e) {
        if (!e) {
            return
        }
        setOnSelectMenu(false);
        setCollapse({
            ...collapse,
            withContent: false,
            height: 'min'
        })

        if (isEventTab) {
            setDynamicData(e);
        }

        if (isEstablishment) {
            setDynamicData(e);
        }
    }

    function onSelectedActionClick(e) {
        setOnSelectMenu(false);
        setCollapse({
            ...collapse,
            withContent: false,
            arrowPosition: true,
        })

        if (isEventTab) {
            setEventClick(e)

        }

    }

    function onChangeTab(selected) {
        setOnSelectMenu(false);
        setBackButtonCollapse({
            ...backButtonCollapse,
            visible: false
        })
        setCollapse({
            ...collapse,
            withContent: false,
            arrowPosition: true,
        })

        if (selected === tabs.establishment.slug) {
            setSelectedTab(tabs.establishment.slug);
            setEventFilter(null);
        }
        if (selected === tabs.events.slug) {
            setSelectedTab(tabs.events.slug);
            setEstablishmentFilter(null);
        }
    }

    function onChangeModalLocation() {
        setEventClick(false);
    }

    function onLoadingChildrens(data) {
        createDynamicData(data)
    }

    function onRenderTabCount(count) {
        setRenderTabCount(count)
    }

    function onPermissionChange(result) {
        if (result.state === 'granted') {
            getGeolocationFromUser()
        }

        if (!result.state || result.state === 'prompt' || result.state === 'denied') {
            const latitude = import.meta.env.VITE_BASE_LAT
            const longitude = import.meta.env.VITE_BASE_LONG
            const city = import.meta.env.VITE_BASE_CITY
            const data = {
                lat: latitude,
                long: longitude,
            }

            setLocationLoading(false);
            setLatitude(latitude);
            setLongitude(longitude);
            setUserLocale(data)
            setUserLocation(data)
            setCurrentLocation({
                city
            })
            setRenderMap(true)
        }
    }

    return (
        <>
            <div id="scroll-top-anchor" />
            <Container>
                {/* {
                    !!currentLocation?.city &&
                    <ContentSelectLocation>
                        <SelectLocation onClick={showLocation} textButton={currentLocation?.city} />
                    </ContentSelectLocation>
                } */}

                {/* <TopActions onChangeTab={(tab) => onChangeTab(tab)} /> */}

                <LeftPanel $mobileHidden={mobileView === 'map'} $mapHidden={!mapVisible}>
                    <MobileSearchBar onClick={() => setShowSearchOverlay(true)}>
                        <MobileSearchInput
                            readOnly
                            placeholder={isEstablishment ? 'Procurar estabelecimentos...' : 'Procurar eventos...'}
                        />
                        <MobileSearchIconButton onClick={() => setShowSearchOverlay(true)}>
                            <Search size={16} color={colors.nightLight} />
                        </MobileSearchIconButton>
                    </MobileSearchBar>
                    <HomeTabsContainer>
                        <Text
                            name='highlight'
                            color={colors.nightDark}
                        >
                            Escolha o que buscar
                        </Text>
                        <HomeTabs>
                            <TabsRow>
                                <HomeTabItem
                                    selected={selectedTab === tabs.events.slug}
                                    onClick={() => {
                                        onChangeTab(tabs.events.slug);
                                        navigate(paths.events.home);
                                    }}
                                >
                                    <Row fullyCentralized width='auto'>
                                        <Column width='25px' height='25px'>
                                            <Icon name='cheers' color={selectedTab === tabs.events.slug ? colors.neutralLight : colors.night} />
                                        </Column>
                                        <Text color={selectedTab === tabs.events.slug ? colors.neutralLight : colors.night} marginLeft={'6px'} paddingBottom={0}>Eventos</Text>
                                    </Row>
                                </HomeTabItem>
                                <HomeTabItem
                                    selected={selectedTab === tabs.establishment.slug}
                                    onClick={() => {
                                        onChangeTab(tabs.establishment.slug);
                                        navigate(paths.establishments.home);
                                    }}
                                >
                                    <Row fullyCentralized width='auto'>
                                        <Column width='25px' height='25px'>
                                            <Icon name='store' color={selectedTab === tabs.establishment.slug ? colors.neutralLight : colors.night} />
                                        </Column>
                                        <Text color={selectedTab === tabs.establishment.slug ? colors.neutralLight : colors.night} marginLeft={'6px'} paddingBottom={0}>Estabelecimentos</Text>
                                    </Row>
                                </HomeTabItem>
                            </TabsRow>

                            <RightControls>
                                <MapToggleButton
                                    onClick={() => setMapVisible(v => !v)}
                                    title={mapVisible ? 'Ocultar mapa' : 'Mostrar mapa'}
                                >
                                    {mapVisible ? <EyeOff size={16} /> : <MapIcon size={16} />}
                                    <span>{mapVisible ? 'Ocultar mapa' : 'Mostrar mapa'}</span>
                                </MapToggleButton>

                                <HomeTabItem city onClick={() => setShowLocationModal(true)}>
                                    <Row fullyCentralized width='auto'>
                                        <MapPin color={colors.homeAccent} size={16} />
                                        <Text
                                            marginLeft={'8px'}
                                            marginRight={'8px'}
                                            paddingBottom={0}
                                            color={colors.homeAccent}
                                        >
                                            {currentLocation?.city || 'Todas as cidades'}
                                        </Text>
                                        <ChevronDown color={colors.homeAccent} size={16} />
                                    </Row>
                                </HomeTabItem>
                            </RightControls>
                        </HomeTabs>
                    </HomeTabsContainer>

                    <Routes>
                        <Route
                            path={paths.events.home}
                            element={
                                <EventsV2
                                    filterClick={filterClick}
                                    onLoadData={(e) => onLoadingChildrens(e)}
                                    onLoading={(e) => onRenderTabCount(e)}
                                    eventClick={eventClick}
                                    setEventClick={setEventClick}
                                />
                            }>
                        </Route>

                        <Route
                            path={paths.establishments.home}
                            element={
                                <EstablishmentsV2
                                    onLoadData={(e) => onLoadingChildrens(e)}
                                    onLoading={(e) => onRenderTabCount(e)}
                                />
                            }>
                        </Route>
                    </Routes>

                    <Column width='0' height='0'>
                        <Outlet />
                    </Column>
                </LeftPanel>

                {/* <FloatCenteredItem>
                <FilterButton
                    size='small'
                    variant='secondary'
                    onClick={() => upCollapse()}
                >
                    <Column width='14px' height={'14px'}>
                        <Icon
                            name='filter'
                            color={colors.night}
                        />
                    </Column>
                    <Text
                        name='small'
                        color={colors.night}
                        paddingLeft={'8px'}
                        paddingBottom={0}
                    >
                        Filtrar ou Pesquisar
                    </Text>
                </FilterButton>
            </FloatCenteredItem > */}

                <HommeCollapse
                    visible={mainCollapse?.visible}
                    onClose={() => setMainCollapse({ visible: false, componentToRender: false })}
                >
                    {mainCollapse?.visible && mainCollapse?.componentToRender()}
                </HommeCollapse>


                <MapContainer $mobileMapOpen={mobileView === 'map'} $desktopHidden={!mapVisible}>
                    {mobileView === 'map' && (
                        <MapBackButton onClick={() => setMobileView('list')}>
                            <ArrowLeft size={18} color={colors.nightDark} />
                        </MapBackButton>
                    )}
                    {mobileView === 'map' && (
                        <MapTabToggle>
                            <MapTabPill
                                $active={selectedTab === tabs.events.slug}
                                onClick={() => {
                                    onChangeTab(tabs.events.slug);
                                    navigate(paths.events.home);
                                }}
                            >
                                Eventos
                            </MapTabPill>
                            <MapTabPill
                                $active={selectedTab === tabs.establishment.slug}
                                onClick={() => {
                                    onChangeTab(tabs.establishment.slug);
                                    navigate(paths.establishments.home);
                                }}
                            >
                                Estabelecimentos
                            </MapTabPill>
                        </MapTabToggle>
                    )}

                    {
                        locationLoading || !dynamicData ? (
                            <StyledPlaceholder src='/assets/images/map-placeholder.png' />
                        ) : (
                            <Map
                                withUserLocation
                                latitude={latitude}
                                longitude={longitude}
                                data={dynamicData?.data}
                                multiples={dynamicData?.withMultiples}
                                onMarkerClick={(item) => {
                                    if (isEstablishment) {
                                        navigate(`/estabelecimento/${item.slug}/detalhes`);
                                    } else {
                                        setEventDetailModal(item);
                                    }
                                }}
                                onMultipleMarkersClick={(items) => setMainCollapse({
                                    visible: true,
                                    componentToRender: () => (
                                        <MultipleEventsListV2
                                            data={items}
                                            onEventClick={(event) => {
                                                setMainCollapse({ visible: false, componentToRender: false });
                                                setEventDetailModal(event);
                                            }}
                                        />
                                    )
                                })}
                            />
                        )
                    }

                    {(isEstablishment ? !!establishmentFilter : !!eventFilter) && (
                        <MapClearFiltersButton
                            onClick={() => isEstablishment ? setEstablishmentFilter(null) : setEventFilter(null)}
                        >
                            <X size={14} />
                            <span>Limpar filtros</span>
                        </MapClearFiltersButton>
                    )}
                </MapContainer>

                <ModalLocation
                    data={cityAthorized}
                    onChangeModalLocation={onChangeModalLocation}
                />

                {
                    !!invitePermissionModal && (
                        <InvitePermissionAlert
                            visible={!!invitePermissionModal}
                            data={invitePermissionModal}
                            onClose={() => onClosePermissionModal()}
                        />
                    )
                }

                {
                    !!teamInviteModal && (
                        <TeamInviteAlert
                            visible={!!teamInviteModal}
                            data={teamInviteModal}
                            onClose={() => onCloseTeamInviteModal()}
                        />
                    )
                }
            </Container>
            {isEstablishment
                ? <EstablishmentFiltersModal
                    isOpen={isFiltersOpen}
                    onClose={() => setIsFiltersOpen(false)}
                  />
                : <FiltersModal
                    isOpen={isFiltersOpen}
                    onClose={() => setIsFiltersOpen(false)}
                  />
            }
            <LoginModal
                isOpen={showLoginModal}
                onClose={() => setShowLoginModal(false)}
            />
            <ModalV2
                isOpen={!!eventDetailModal}
                size='medium'
                align='top-center'
                closeButton={false}
                mobileSheet
                onClose={() => setEventDetailModal(false)}
            >
                {eventDetailModal && (
                    <EventDetailV2
                        data={eventDetailModal}
                        fromHome={true}
                        onClose={() => setEventDetailModal(false)}
                    />
                )}
            </ModalV2>
            <Footer />
            <Navbar
                onMapToggle={() => setMobileView(mobileView === 'map' ? 'list' : 'map')}
                isMapView={mobileView === 'map'}
            />
        </>
    )
}


const Container = styled(Column)`
    width: 100%;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        background-color: ${colors.neutralBackground};
        margin-top: 80px;
    }
`;

const LeftPanel = styled.div`
    width: 100%;
    padding: 16px 16px 80px;

    @media screen and (min-width: ${breakpoints.lg}) {
        flex: 1;
        min-width: 0;
        padding: 15px 30px;
    }

    ${({ $mobileHidden }) => $mobileHidden && css`
        @media screen and (max-width: calc(${breakpoints.lg} - 1px)) {
            display: none;
        }
    `}

    ${({ $mapHidden }) => $mapHidden && css`
        @media screen and (min-width: ${breakpoints.lg}) {
            max-width: 1200px;
            margin: 0 auto;
        }
    `}
`;

const ContentSelectLocation = styled.div`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        width: 35vw;
        display: flex;
        flex-direction: row;
        position: fixed;
        top: 130px;
        right: 0;
        justify-content: center;
        align-items: center; 
        z-index: 1;
    }
`;

const StyledPlaceholder = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const MapContainer = styled.div`
    /* Mobile: always rendered at full size so Google Maps loads tiles.
       visibility + z-index control show/hide instead of display:none,
       which would starve the map of dimensions and cause gray tiles. */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100dvh;
    z-index: -1;
    visibility: hidden;
    pointer-events: none;

    @media screen and (max-width: calc(${breakpoints.lg} - 1px)) {
        ${({ $mobileMapOpen }) => $mobileMapOpen && css`
            z-index: ${indexPriority.enormous};
            visibility: visible;
            pointer-events: auto;
        `}
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        position: sticky;
        top: 80px;
        left: auto;
        right: auto;
        bottom: auto;
        width: 38vw;
        height: calc(100vh - 80px);
        z-index: auto;
        visibility: visible;
        pointer-events: auto;
        align-self: flex-start;
        flex-shrink: 0;
        ${({ $desktopHidden }) => $desktopHidden && `display: none;`}
    }
`;

const MapClearFiltersButton = styled.button`
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        position: absolute;
        bottom: 24px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        gap: 6px;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        border: 1px solid ${colors.night}22;
        border-radius: 20px;
        padding: 8px 16px;
        font-size: 13px;
        font-weight: 600;
        color: ${colors.nightDark};
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        z-index: 10;
        white-space: nowrap;
        transition: all 0.15s ease;

        &:hover {
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
    }
`;

const HomeTabsContainer = styled(Column)`
    width: 100%;
    margin-top: 18px;
`;

const HomeTabs = styled(Row)`
    width: 100%;
    align-items: center;

    @media screen and (max-width: calc(${breakpoints.lg} - 1px)) {
        flex-direction: column;
    }
`;

const TabsRow = styled(Row)`
    width: 100%;
    background: ${colors.neutralDark};
    border-radius: 10px;
    padding: 3px;

    @media screen and (min-width: ${breakpoints.lg}) {
        width: auto;
    }
`;

const HomeTabItem = styled.button`
    border: none;
    border-radius: 8px;
    background-color: transparent;
    color: ${colors.night};
    padding: 6px 12px;
    cursor: pointer;
    transition: color 0.15s ease;
    flex: 1;

    &:hover {
        color: ${colors.homeAccent};
    }

    ${({ city }) => city && css`
        flex: none;
        width: auto;
        background-color: transparent;
        border: 1px solid ${colors.homeAccent}60;
        border-radius: 50px;
        padding: 6px 12px;
        transition: all 0.15s ease;

        &:hover {
            background-color: ${colors.homeAccent}10;
            border-color: ${colors.homeAccent}80;
        }

        &:hover p, &:hover svg {
            color: ${colors.homeAccent} !important;
            stroke: ${colors.homeAccent} !important;
        }

        @media screen and (max-width: calc(${breakpoints.lg} - 1px)) {
            width: 100%;
            margin-left: 0;
            margin-top: 8px;
            justify-content: center;
            border: 1px solid ${colors.night}22;
            border-radius: 10px;
            padding: 10px 16px;
        }
    `}

    ${({ selected }) => selected && css`
        background: ${colors.homeAccent};
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        color: ${colors.neutralLight};
    `}
`;

const MobileSearchBar = styled(Row)`
    display: flex;
    align-items: center;
    border: 1px solid ${colors.night}22;
    border-radius: 10px;
    padding: 10px 16px;
    gap: 8px;
    margin-bottom: 12px;
    background: ${colors.neutralLight};
    cursor: pointer;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: none;
    }
`;

const MobileSearchIconButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    flex-shrink: 0;
`;

const MobileSearchInput = styled.input`
    border: none;
    outline: none;
    width: 100%;
    font-size: 14px;
    background: transparent;
    color: ${colors.nightDark};

    &::placeholder {
        color: ${colors.nightLight};
    }
`;



const RightControls = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;

    @media screen and (max-width: calc(${breakpoints.lg} - 1px)) {
        width: 100%;
        margin-left: 0;
        flex-direction: column;
        gap: 0;
    }
`;

const MapToggleButton = styled.button`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        border-radius: 8px;
        border: 1.5px solid ${colors.neutralDark};
        background: #fff;
        font-size: 13px;
        font-weight: 500;
        color: ${colors.night};
        cursor: pointer;
        transition: all 0.15s;
        &:hover { background: ${colors.neutralDark}; }
    }
`;


const MapTabToggle = styled.div`
    position: fixed;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
    z-index: ${indexPriority.tremendous};
    display: flex;
    background: rgba(255,255,255,0.95);
    backdrop-filter: blur(8px);
    border-radius: 24px;
    padding: 3px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    gap: 2px;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: none;
    }
`;

const MapTabPill = styled.button.withConfig({
    shouldForwardProp: (prop) => !['$active'].includes(prop),
})`
    padding: 8px 18px;
    border-radius: 20px;
    border: none;
    font-size: 13px;
    font-weight: ${({ $active }) => $active ? '700' : '500'};
    background: ${({ $active }) => $active ? colors.nightDark : 'transparent'};
    color: ${({ $active }) => $active ? '#fff' : colors.night};
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
`;

const MapBackButton = styled.button`
    position: fixed;
    top: 20px;
    left: 16px;
    z-index: ${indexPriority.tremendous};
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(8px);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
        background: ${colors.neutralDark};
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        display: none;
    }
`;
